import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, Dimensions, View } from 'react-native';
import { Avatar } from '@ui-kitten/components';
import { useSelector} from 'react-redux';

const EditIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='edit-2'/>
);

export const AvatarH = () => {
  const user =  useSelector( state => state.login.information);

  return (
      <View style={{ alignItems:'center', marginBottom:10}}>
      <SafeAreaView>
        <Avatar
          style={{width:128,height:128, marginVertical:10, borderWidth:3, borderColor:'#CEE8F9'}}
          source={{uri: `https://api.fntpf.ir/assets/uploaded/images/${user.img_uri}`}}
          size='giant'
          />
          <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
            <View />
            <View style={{alignItems:'center'}}>
            { user && user.score &&
              <Text status='primary' style={{backgroundColor:'#ffd700', borderRadius:5, paddingHorizontal:5}}>امتیاز: {user.score}</Text>
            }
              <Text style={{color: '#CEE8F9'}}>{user.firstname} {user.lastname}</Text>
              <Text appearance='hint'>{user.phone}</Text>
              <Text category='c2' appearance='hint'>کد تکنسین: {user.id}</Text>
            </View>
            <View>
            </View>
          </View>
          </SafeAreaView>
      </View>
  );
};
